export default "__VITE_ASSET__BqIyK3_r__"